// Jarak GPS — port haversine() & fmtDist v1 (ops.js). Dipakai SPO Baru (toko terdekat), pelacak GPS driver/sales
// (kirim posisi bila pindah ≥15 m) & Peta Live (panjang jejak). Panah belokan navigasi memakai fmtM (driver/arrow.tsx):
// pembulatan berbeda (minimal "10 m"), sengaja tidak digabung.

export interface LatLng {
  latitude: number;
  longitude: number;
}

/** Jarak dua titik (meter). Bentuk titik sama dengan GeolocationCoordinates ({ latitude, longitude }). */
export function haversine(a: LatLng, b: LatLng): number {
  const R = 6371000;
  const r = Math.PI / 180;
  const dLat = (b.latitude - a.latitude) * r;
  const dLng = (b.longitude - a.longitude) * r;
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(a.latitude * r) * Math.cos(b.latitude * r) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

/** "120 m" / "1,4 km" ('' bila tidak diketahui). */
export const fmtDist = (m: number | null): string =>
  m == null ? '' : m < 1000 ? `${Math.round(m / 10) * 10} m` : `${(m / 1000).toFixed(1).replace('.', ',')} km`;
